export default {
    zh: {
      timeR: '倒计时: ',
      ruleText:'规则',
      DailyBenefits:'每日福利',
      rule:'1-评论商店中应用程序的评估（5星评论并在注册请求期间发送屏幕截图）</br>2- 参与者必须活动 2 小时。任何静音操作都不会被计算在内。</br>3-每周将发送两次奖励。参与者将在周一和周五收到 6000 个硬币。每周最多 12,000 个硬币。</br>4- 每个用户只能在一台设备上注册，如果在一台设备上检测到多个帐户，将直接取消订阅。</br>5- 一旦您获得资格，ID 1 将与您联系。',
      content:'宰牲节的时间到了。</br>为了庆祝宰牲节</br>前 3 名用户将获得稀有而独特的奖牌。</br>房间也会收到礼物。</br>只有以下礼物将被计算在内：',
      mission:'任务',
      ranking:'排行',
      individual:'个人',
      room:'房间',
      rewards:'奖励',
      amount:'完成额度',
      collect:'收集',
      copyright:'本活动版权归App所有',
      collected:'收到',
      specialgift:'special background gift',
    },
    en: { 
      timeR: 'Count down: ',
      ruleText:'Rule',
      DailyBenefits:'Daily Benefits',
      rule:'1- Comment an evaluation of the application in the store (5 stars with a comment and sending a screenshot during the registration request)</br>2- Participants must be active for 2 hours. Any mute action will not be counted. </br>3- Rewards will be sent out twice every week. Participants will received 6000 coins, monday and friday. 12,000 coins max per week.</br>4- Each user can register from one device only, and if more than one account is detected on one device, the subscription will be canceled directly.</br>5- Once you have qualified, ID 1 will contact you.',
      content:'It is time for Eid al-Adha.  </br>To celebrate Eid al-Adha date, </br>Rare and unique medals will be given to top 3 users.</br>Rooms will also receive gifts.</br>Only the following gifts will be counted:',
      mission:'mission',
      ranking:'ranking',
      individual:'individual',
      room:'room',
      rewards:'rewards',
      amount:'Amount accomplished',
      collect:'collect',
      copyright:'The copyright of this activity belongs to App',
      collected:'received',
      specialgift:'special background gift',
    },
    ar: {
      timeR: 'العد التنازلي ',
      ruleText:'قواعد',
      DailyBenefits:'المكافأة اليومية',
      rule:'1- التعليق على تقييم التطبيق في المتجر (5 نجوم مع تعليق وإرسال لقطة شاشة أثناء طلب التسجيل)</br>2- يجب أن يكون المشاركون نشطين لمدة ساعتين. لن يتم احتساب أي إجراء كتم الصوت.</br>3- سيتم إرسال المكافآت مرتين كل أسبوع. سيحصل المشاركون على 6000 قطعة نقدية يوم الاثنين والجمعة. 12000 قطعة نقدية كحد أقصى في الأسبوع.</br>4- يمكن لكل مستخدم التسجيل من جهاز واحد فقط ، وفي حالة اكتشاف أكثر من حساب على جهاز واحد يتم إلغاء الاشتراك مباشرة.</br>5- بمجرد أن تصبح مؤهلاً ، سيتصل بك ID 1.',
      content:'حان وقت عيد الأضحى.</br>للاحتفال بعيد الأضحى المبارك ،</br>سيتم منح ميداليات نادرة وفريدة من نوعها لأفضل 3 مستخدمين.</br>ستحصل الغرف أيضًا على هدايا.</br>سيتم احتساب الهدايا التالية فقط:',
      mission:'بعثة',
      ranking:'تصنيف',
      individual:'فرد',
      room:'مجال',
      rewards:'المكافآت',
      amount:'المبلغ المنجز',
      collect:'يجمع',
      copyright:'حقوق الطبع والنشر لهذا النشاط تعود إلى App',
      collected:'استلم',
      specialgift:'هدية خلفية خاصة',
    },
    tr: {
      timeR: 'Kalan süre: ',
      ruleText:'Rule',
      DailyBenefits:'Daily Benefits',
      rule:"1- Mağazadaki uygulamanın bir değerlendirmesini yorumlayın (kayıt talebi sırasında bir yorum ve ekran görüntüsü gönderme ile 5 yıldız)</br>2- Katılımcılar 2 saat aktif olmalıdır. Herhangi bir sessize alma işlemi sayılmaz.</br>3- Ödüller her hafta iki kez gönderilecektir. Katılımcılar pazartesi ve cuma günleri 6000 jeton alacaklar. Haftada maksimum 12.000 jeton.</br>4- Her kullanıcı sadece bir cihazdan kayıt olabilir ve bir cihazda birden fazla hesap tespit edilirse abonelik doğrudan iptal edilir.</br>5- Kalifiye olduktan sonra ID 1 sizinle iletişime geçecektir.",
      content:'Kurban Bayramı vakti geldi.</br>Kurban Bayramı tarihini kutlamak için,</br>İlk 3 kullanıcıya nadir ve benzersiz madalyalar verilecek.</br>Odalara ayrıca hediyeler verilecektir.</br>Yalnızca aşağıdaki hediyeler sayılacaktır:',
      mission:'misyon',
      ranking:'sıralama',
      individual:'bireysel',
      room:'oda',
      rewards:'ödüller',
      amount:'Tamamlanan miktar',
      collect:'toplamak',
      copyright:"Bu etkinliğin telif hakkı App'ye aittir.",
      collected:'alındı',
      specialgift:'özel arka plan hediyesi',
    },
    jp: {
      timeR: 'カウントダウン: ',
      ruleText:'Rule',
      DailyBenefits:'Daily Benefits',
      rule:'1-ストアでアプリケーションの評価をコメントします（コメント付きの5つ星と、登録リクエスト中にスクリーンショットを送信します）</br>2- 参加者は 2 時間アクティブである必要があります。ミュート操作はカウントされません。</br>3- 報酬は毎週 2 回配信されます。参加者は月曜日と金曜日に 6000 コインを受け取ります。 1 週間あたり最大 12,000 コイン。</br>4- 各ユーザーは 1 つのデバイスからのみ登録できます。1 つのデバイスで複数のアカウントが検出された場合、サブスクリプションは直接キャンセルされます。</br>5- 資格を取得したら、ID 1 から連絡があります。',content:'イード・アル＝アドハーの時間です。</br>イードアルアドハーの日付を祝うために、</br>珍しいユニークなメダルが上位3人のユーザーに贈られます。</br>客室にもギフトが贈られます。</br>次のギフトのみがカウントされます。',
      mission:'ミッション',
      ranking:'ランキング',
      individual:'個人',
      room:'部屋',
      rewards:'報酬',
      amount:'達成量',
      collect:'収集',
      copyright:'この活動の著作権はAppに帰属します',
      collected:'受信',
      specialgift:'特別な背景ギフト',
    },
    pt:{
      "timeR": "Contagem regressiva: ",
      "ruleText": "Regra",
      "DailyBenefits": "Benefícios Diários",
      "rule": "1- Comente uma avaliação do aplicativo na loja (5 estrelas com um comentário e enviando uma captura de tela durante a solicitação de registro)</br>2- Os participantes devem ser ativos por 2 horas. Qualquer ação de mudo não será contada. </br>3- As recompensas serão enviadas duas vezes por semana. Os participantes receberão 6000 moedas, na segunda-feira e na sexta-feira. Máximo de 12.000 moedas por semana.</br>4- Cada usuário pode se registrar de um único dispositivo, e se mais de uma conta for detectada em um único dispositivo, a inscrição será cancelada diretamente.</br>5- Após qualificação, o ID 1 entrará em contato com você.",
      "content": "É hora do Eid al-Adha. </br>Para celebrar a data do Eid al-Adha, </br>Medalhas raras e únicas serão dadas aos 3 melhores usuários.</br>As salas também receberão presentes.</br>Somente os seguintes presentes serão contados:",
      "mission": "missão",
      "ranking": "ranking",
      "individual": "individual",
      "room": "sala",
      "rewards": "recompensas",
      "amount": "Quantidade realizada",
      "collect": "coletar",
      "copyright": "Os direitos autorais desta atividade pertencem ao App",
      "collected": "recebido",
      "specialgift": "presente especial de fundo"
},
    id:{
      "timeR": "Hitung mundur: ",
      "ruleText": "Aturan",
      "DailyBenefits": "Manfaat Harian",
      "rule": "1- Komentari penilaian aplikasi di toko (5 bintang dengan komentar dan mengirimkan screenshot selama permintaan pendaftaran)</br>2- Peserta harus aktif selama 2 jam. Setiap tindakan diam tidak akan dihitung. </br>3- Hadiah akan dikirim dua kali setiap minggu. Peserta akan menerima 6000 koin, pada hari Senin dan Jumat. Maksimal 12.000 koin per minggu.</br>4- Setiap pengguna hanya dapat mendaftar dari satu perangkat, dan jika lebih dari satu akun terdeteksi di satu perangkat, langganan akan dibatalkan secara langsung.</br>5- Setelah Anda memenuhi syarat, ID 1 akan menghubungi Anda.",
      "content": "Saatnya untuk Eid al-Adha. </br>Untuk merayakan tanggal Eid al-Adha, </br>Medali langka dan unik akan diberikan kepada 3 pengguna terbaik.</br>Ruangan juga akan menerima hadiah.</br>Hanya hadiah berikut yang akan dihitung:",
      "mission": "misi",
      "ranking": "peringkat",
      "individual": "individu",
      "room": "ruang",
      "rewards": "hadiah",
      "amount": "Jumlah yang tercapai",
      "collect": "kumpulkan",
      "copyright": "Hak cipta kegiatan ini milik Aplikasi",
      "collected": "diterima",
      "specialgift": "hadiah latar belakang khusus"
},
    uz:{
      "timeR": "Aqibatni hisoblash: ",
      "ruleText": "Qoidalar",
      "DailyBenefits": "Kunlik Foydalar",
      "rule": "1- Do'konda ilovaning bahosini izohlash (5 yulduz bilan izoh va ro'yxatdan o'tish so'rovi davomida skrinshot yuborish)</br>2- Ishtirokchilar 2 soat davomida faol bo'lishlari kerak. Har qanday jimlik harakati hisobga olinmaydi.</br>3- Mukofotlar har hafta ikki marta yuboriladi. Ishtirokchilar 6000 tangani dushanba va juma kunlari olishadi. Haftasiga maksimal 12 000 tanga.</br>4- Har bir foydalanuvchi faqat bitta qurilmadan ro'yxatdan o'tishi mumkin, agar bir qurilmada bir nechta hisoblar aniqlansa, obuna to'g'ridan-to'g'ri bekor qilinadi.</br>5- Siz malakali bo'lgach, ID 1 siz bilan bog'lanadi.",
      "content": "Eid al-Adha vaqti keldi. </br>Eid al-Adha sanasini nishonlash uchun, </br>Top 3 foydalanuvchiga noyob va kamdan-kam medallar beriladi.</br>Xonalar ham sovg'alar olishadi.</br>Faqat quyidagi sovg'alar hisobga olinadi:",
      "mission": "missiya",
      "ranking": "reyting",
      "individual": "shaxsiy",
      "room": "xona",
      "rewards": "sovg'alar",
      "amount": "Bajargan miqdori",
      "collect": "to'plash",
      "copyright": "Ushbu faoliyatning mualliflik huquqi App-ga tegishlidir",
      "collected": "olindi",
      "specialgift": "maxsus fon sovg'asi"
},
    ru:{
      "timeR": "Обратный отсчет: ",
      "ruleText": "Правило",
      "DailyBenefits": "Ежедневные бонусы",
      "rule": "1- Оставьте оценку приложения в магазине (5 звезд с комментарием и отправкой скриншота при регистрации)</br>2- Участники должны быть активны в течение 2 часов. Любое действие с отключением звука не будет засчитано.</br>3- Награды будут отправляться дважды в неделю. Участники получат 6000 монет в понедельник и пятницу. Максимум 12 000 монет в неделю.</br>4- Каждый пользователь может зарегистрироваться только с одного устройства, и если на одном устройстве будет обнаружено несколько аккаунтов, подписка будет немедленно отменена.</br>5- После того как вы станете квалифицированным, ID 1 свяжется с вами.",
      "content": "Время для праздника Ид аль-Адха.</br>Для празднования даты Ид аль-Адха, </br>Редкие и уникальные медали будут вручены топ-3 пользователям.</br>Комнаты также получат подарки.</br>Будут засчитаны только следующие подарки:",
      "mission": "миссия",
      "ranking": "рейтинг",
      "individual": "индивидуальный",
      "room": "комната",
      "rewards": "награды",
      "amount": "Выполненное количество",
      "collect": "собрать",
      "copyright": "Авторские права на это мероприятие принадлежат приложению",
      "collected": "получено",
      "specialgift": "специальный фон подарок"
},
    fa:{
      "timeR": "شمارش معکوس: ",
      "ruleText": "قانون",
      "DailyBenefits": "مزایای روزانه",
      "rule": "1- ارزیابی برنامه را در فروشگاه کامنت کنید (5 ستاره با نظر و ارسال اسکرین شات هنگام درخواست ثبت نام)</br>2- شرکت کنندگان باید به مدت 2 ساعت فعال باشند. هرگونه اقدام بی صدا شمارش نخواهد شد.</br>3- جوایز دو بار در هفته ارسال خواهد شد. شرکت کنندگان 6000 سکه در دوشنبه و جمعه دریافت خواهند کرد. حداکثر 12000 سکه در هفته.</br>4- هر کاربر می‌تواند تنها از یک دستگاه ثبت نام کند، و اگر بیشتر از یک حساب در یک دستگاه شناسایی شود، اشتراک به طور مستقیم لغو خواهد شد.</br>5- هنگامی که شما واجد شرایط شدید، ID 1 با شما تماس خواهد گرفت.",
      "content": "زمان عید قربان فرا رسیده است.</br>برای جشن گرفتن تاریخ عید قربان، </br>مدال‌های نادر و منحصر به فرد به 3 کاربر برتر داده خواهد شد.</br>اتاق‌ها نیز جوایزی دریافت خواهند کرد.</br>فقط هدایای زیر شمارش خواهند شد:",
      "mission": "ماموریت",
      "ranking": "رتبه بندی",
      "individual": "شخصی",
      "room": "اتاق",
      "rewards": "جوایز",
      "amount": "مقدار انجام شده",
      "collect": "جمع آوری",
      "copyright": "حق نسخه‌برداری این فعالیت متعلق به اپلیکیشن است",
      "collected": "دریافت شده",
      "specialgift": "هدیه پس زمینه ویژه"
}

  }
  


// WEBPACK FOOTER //
// src/pages/activity/ladiesregister2/lang.js